import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";


export const StyledButton = styled('button', {
  css: [styles.closeButton, 'btn-close'],
  variants: {
    color: {
      dark: [styles.dark],
      light: [styles.light],
    },
    hideLabel: {
      true: [styles.hideLabel]
    },
    labelPosition: {
      left: [styles.labelLeft],
      right: [styles.labelRight]
    }

  }
})
